import { ICongThucTinhDiemSub } from "../../model/response/category/ICongThucTinhDiemSub"
import { apiClient } from "../apiClient"
import { CONG_THUC_TINH_DIEM_ENDPOINT } from "./congThucTinhDiemApi"

export const CONG_THUC_TINH_DIEM_SUB_ENDPOINT = "cong-thuc-tinh-diem-sub"
export const congThucTinhDiemSubApi = {
    SelectAll: () => apiClient.get(`${CONG_THUC_TINH_DIEM_SUB_ENDPOINT}`),
    Insert: (payload: ICongThucTinhDiemSub) => apiClient.post(`${CONG_THUC_TINH_DIEM_SUB_ENDPOINT}`, payload),
    Update: (id: number,payload: ICongThucTinhDiemSub) => apiClient.put(`${CONG_THUC_TINH_DIEM_SUB_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${CONG_THUC_TINH_DIEM_SUB_ENDPOINT}/${id}`),
    SelectByCongThuc: (id_cong_thuc: number) => apiClient.get(`${CONG_THUC_TINH_DIEM_ENDPOINT}/${id_cong_thuc}/chi-tiet`)
}